export default __webpack_public_path__ + "static/media/access-one-false.3b5e4521.svg";